<template>
  <div style="background-color: #f1f2f5;padding: 20px">
    <div style="background-color: #fff;padding: 20px">
      <div />
      <el-button icon="el-icon-upload" type="warning" @click="openFileDialog">选择本地文件</el-button>
      <input
        ref="fileInput"
        type="file"
        accept="video/*"
        multiple
        style="display: none"
        @change="handleFileChange"
      >
      <span style="margin: 0 15px">上传状态：</span>
      <el-select v-model="query.status" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" style="margin: 0 5px" @click="materialList"> 查询</el-button>
    </div>
    <div>
      <div class="sticky-header">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-checkbox
              :indeterminate="isIndeterminate"
              :checked="isChecked"
              @change="handleToggleAll"
            >
              全选
            </el-checkbox>
            <el-tag
              style="margin:0 5px"
              closable
              @close="handleToggleAll(false)"
            >
              已选{{ selectedItems.length }}
            </el-tag>
            名称：<el-input v-model="file_text" style="width: 200px;margin: 0 5px" />
            tag_id: <el-input v-model="tag_id" style="width: 200px;margin: 0 5px" /><span style="color: red;margin: 0 15px">*只会修改第一条tag_id*</span>
            <el-button type="primary" :disabled="!selectedItems.length" @click="editAll">一键修改已选中</el-button>
          </div>
          <div>
            <el-button
              type="success"
              :disabled="!selectedItems.length"
              @click="uploadMaterial"
            >上传</el-button>
            <!--            <el-button-->
            <!--              type="danger"-->
            <!--              :disabled="!selectedItems.length"-->
            <!--              @click="deleteAll"-->
            <!--            >删除</el-button>-->
          </div>
        </div>
      </div>
      <div style="display: flex;flex-wrap: wrap">
        <div
          v-for="(item, index) in videoList.list"
          :key="index"
          style="width: 318px;height: 352px;margin: 10px 8px;background-color: #FFFFFF;border-radius: 5px"
        >
          <div
            style="height: 48px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer"
            @click.stop="checkItem(item)"
          >
            <div style="display: flex;align-items: center;">
              <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px;">
                <div style="display: flex; align-items: center;">
                  <div v-if="!item.editing" style="display: flex; align-items: center;" @click.stop="editName(item)">
                    <div
                      style="
                        margin-bottom: 7px;
                        font-weight: 600;
                        font-size: 16px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        max-width: 150px;
                      "
                    >
                      {{ item.file_text }}
                    </div>
                    <i v-if="item.status !== 2" class="el-icon-edit" style="margin-left: 5px; cursor: pointer;" @click.stop="editName(item)" />
                  </div>
                  <el-input
                    v-else
                    v-model="item.file_text"
                    size="small"
                    style="width: 230px; margin-bottom: 7px;"
                    @blur="finishEdit(item)"
                    @keyup.enter.native="finishEdit(item)"
                  />
                </div>
              </div>
            </div>
            <div style="text-align: end">
              <el-checkbox
                v-if="item.status===1"
                :value="selectedItems.includes(item)"
                style="pointer-events: none"
                @click.native.stop
              />
              <!--              <div style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">123123123</div>-->
              <el-tag v-else-if="item.status === 2" type="warning"> 上传中。。 </el-tag>
              <el-tag v-else-if="item.status === 3" type="success"> 已上传 </el-tag>
              <el-tag v-else-if="item.status === 4" type="danger"> 上传失败 </el-tag>
            </div>
          </div>
          <div
            style="cursor: pointer;position: relative;"
            @click="itemInfo(item)"
          >
            <!--          @click="itemInfo(item)"-->
            <video
              :src="config.domain + item.file_name"
              referrerpolicy="no-referrer"
              style="width: 318px;height: 180px;background-color: #B2B2B2;"
              controls
            />
            <!--            object-fit: cover;-->
          </div>

          <div
            style="height: 121px;overflow-y: auto;"
          >
            <el-form v-if="item.status === 1">
              <div v-for="(id, index) in item.tag_ids" :key="index">
                <el-form-item
                  :label="'tag_id' + (index + 1)"
                  class="form-item-center"
                  style="display: flex; align-items: center;"
                >
                  <!-- 新增按钮（只在第一个元素显示） -->
                  <!-- 输入框 -->
                  <el-input v-model="item.tag_ids[index]" style="width: 160px;" />
                  <el-button
                    v-if="index === 0"
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    style="margin-left: 10px;"
                    @click="addBid(item)"
                  />
                  <!-- 删除按钮（非第一个元素时显示） -->
                  <el-button
                    v-if="index > 0"
                    type="danger"
                    icon="el-icon-remove-outline"
                    style="margin-left: 10px;"
                    @click="closeBid(item, index)"
                  />
                </el-form-item>
              </div>
            </el-form>
            <div v-else style="max-height: 121px; overflow-y: auto;padding: 10px">
              <div style="margin-bottom: 5px; font-weight: bold;">标签 IDs：</div>
              <div style="display: flex; flex-wrap: wrap; gap: 5px;">
                <el-tag
                  v-for="(tag, index) in parseTagIds(item.tag_ids)"
                  :key="index"
                >
                  {{ tag }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-right
        :total="videoList.total"
        :page-sizes="[30]"
        :current-page="query.page"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { uploadFileToCos } from '@/utils/ObjectStorage' // 需要自己封装或者写
import { getQcConfig } from '@/api/baiduAD.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// eslint-disable-next-line no-unused-vars
import { localVideoAdd, LocalVideoList, uploadMat, uploadMaterial } from '@/api/report/adx'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        status: '0'
      },
      videoList: {
        list: [],
        total: 2
      },
      config: {
        secret_id: 'xxx',
        secret_key: 'xxx',
        bucket: 'xxx-xxx',
        region: 'ap-xxx',
        domain: 'zyc-dev.jingxuanhz.com'
      },
      selectedItems: [],
      options: [
        { value: '0', label: '全部' },
        { value: '1', label: '待上传' },
        { value: '2', label: '上传中' },
        { value: '3', label: '上传成功' },
        { value: '4', label: '上传失败' }
      ],
      tag_id: null,
      file_text: null
    }
  },
  computed: {
    isChecked() {
      const list = this.videoList?.list || []
      return list.length > 0 && this.selectedItems.length === list.length
    },
    isIndeterminate() {
      const list = this.videoList?.list || []
      return this.selectedItems.length > 0 && this.selectedItems.length < list.length
    }
  },
  created() {
    this.getconfig()
    this.materialList()
  },
  methods: {
    materialList() {
      LocalVideoList(this.query).then((res) => {
        console.log(res)
        this.videoList = res.data
        this.videoList.list.forEach(item => {
          if (!item.tag_ids || item.tag_ids.length === 0) {
            item.tag_ids = ['']
          }
        })
      })
    },
    async getconfig() {
      const res = await getQcConfig()
      console.log(res)
      this.config = res.data.qcconfig
    },
    openFileDialog() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      const files = e.target.files
      if (files.length) {
        Array.from(files).forEach(file => {
          console.log('文件名:', file.name)
          console.log('文件大小:', file.size)
          this.uploadToCosAndSave(file)
          // 这里可以循环调用上传逻辑，比如 uploadFileToCos(file)
        })
      } else {
        console.log('未选择文件')
      }
      this.materialList()
      // 为了可以重复选择同一个文件（比如再次选择相同文件），清空 value
      e.target.value = ''
    },
    uploadToCosAndSave(file) {
      const folderName = 'chameleon' // 你自己想放的文件夹

      uploadFileToCos(file, percent => {
        console.log(`上传进度 ${percent}%`)
      }, folderName, this.config).then(cosKey => {
        // 成功后提示

        // 获取随机文件名部分（Key 里最后一段）
        const cosFileName = cosKey.split('/').pop()

        // 这里拼装你要提交给后台的参数
        const recordParams = {
          file_text: file.name,
          file_name: cosKey,
          cos_file_name: cosFileName
        }
        console.log(recordParams, '这是之后拼装参数到后端')
        // 调用接口把记录存到后台
        this.saveUploadRecord(recordParams)
      }).catch(err => {
        this.$message.error(`${file.name} 上传失败！--${err}`)
      })
    },
    checkItem(item) {
      console.log(item, '1111')
      // eslint-disable-next-line eqeqeq
      if (item.status === 2 || item.upload_status == 1) return // status为1的项目不处理

      const index = this.selectedItems.indexOf(item)
      if (index === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    fetchPageSize(data) {
      this.query.page = 1
      this.query.pageSize = data
      this.materialList()
    },
    fetchCurrentPage(data) {
      this.query.page = data
      this.materialList()
    },
    itemInfo(val) {
      console.log(val)
    },
    addBid(val) {
      val.tag_ids.push('')
    },
    closeBid(val) {
      if (val.tag_ids.length > 1) {
        val.tag_ids.pop()
      } else {
        this.$message.warning('至少保留一个 tag_id')
      }
    },
    editName(item) {
      console.log(item)
      if (item.status === 2) return
      this.$set(item, 'editing', true) // 响应式地新增 editing 属性
    },
    finishEdit(item) {
      item.editing = false
    },
    handleToggleAll(val) {
      if (val) {
        this.selectedItems = this.generateAllItems()
      } else {
        this.selectedItems = []
      }
    },
    uploadMaterial() {
      const material_nos = this.selectedItems.map(item => {
        if (!item.tag_ids || !item.tag_ids[0] || item.tag_ids[0].trim() === '') {
          this.$message.error(`${item.file_text}的 tag_ids不能为空！`)
          throw new Error('验证失败') // 立即中断 map
        }

        // 返回你需要的对象
        return {
          id: item.id,
          file_text: item.file_text,
          tag_ids: item.tag_ids
        }
      })
      console.log(this.material_nos)
      uploadMat({ videos: material_nos }).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.code == 0) {
          this.$message.success('创建任务成功，请等待上传成功')
          this.selectedItems = []
          this.materialList()
        }
      })
    },
    deleteAll() {

    },
    generateAllItems() {
      return this.videoList.list.filter(item => item.status === 1)
    },
    editAll() {
      this.selectedItems.forEach(item => {
        // 判断 file_text 是否有效（不为 null，不为空，不全空格）
        if (this.file_text !== null && this.file_text.trim() !== '') {
          item.file_text = this.file_text
        }

        // 判断 tag_id 是否有效（如果需要也可加同样判断）
        if (this.tag_id !== null && this.tag_id.trim() !== '') {
          if (!item.tag_ids || !Array.isArray(item.tag_ids)) {
            // 如果 tag_ids 没初始化，先初始化为空数组
            this.$set(item, 'tag_ids', [])
          }
          this.$set(item.tag_ids, 0, this.tag_id)
        }
      })

      this.$message.success('已批量修改所有选中项')
    },
    saveUploadRecord(val) {
      console.log(val)
      localVideoAdd(val).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success(`${val.file_text}上传成功！`)
        }
      })
    },
    parseTagIds(tagIds) {
      if (!tagIds) return []

      if (typeof tagIds === 'string') {
        try {
          const arr = JSON.parse(tagIds)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      }

      if (Array.isArray(tagIds)) {
        return tagIds
      }

      return []
    }
  }
}
</script>
<style>
.form-item-center {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中（如果需要） */
}
.sticky-header {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  position: sticky;
  top: 85px;
  z-index: 999;
}
</style>
